import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import {
	Paper, Grid,
	Typography, IconButton
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { yupResolver } from "@hookform/resolvers/yup";
import {
	createCentreFacilityFormSchema,
	INITIAL_CENTRE_FACILITY_FORM
} from "./../../form/model/CentreFormModel";
import { SpaceHolder } from "./../../common/Others";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useCentreManagementState } from "./../../../redux/CentreManagement";
import { deleteFacilityPhoto, useFacilityManagementState } from "./../../../redux/FacilityManagement";
import ConfirmActionDialog from "./../../common/ConfirmActionDialog";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import ContextualMenu from "./../../common/ContextualMenu";
import { ContextualMenuItem } from "./../../common/Buttons";
import ContentRow from "./../../common/ContentRow";
import CarouselImage from "./../../display/CarouselImage";
import CanUpdateCentre from "./../../acl/CanUpdateCentre";
import FacilityDefaultImage from "./../../../asset/facility_default/facility_background.jpg";
import CentreFacilityDialog from "./../centreDetail/dialog/CentreFacilityDialog";
import FacilityUploadImageDialog from "./dialog/FacilityUploadImageDialog";


const HeaderRow = styled(Grid)(({ theme }) => ({
	marginTop: theme.spacing(3),
	marginBottom: theme.spacing(2.5),
}));

export default function FacilityAboutDetailPage() {
	const CENTRE = useCentreManagementState().currentCentre;
	const FACILITY = useFacilityManagementState().currentFacility || {};
	const { t } = useTranslation(["centre", "general"]);
	const [isDialogOpen, setIsDialogOpen] = React.useState(false);
	const [isUploadImageDialogOpen, setIsUploadImageDialogOpen] = React.useState(false);
	const [isDeleteImageDialogOpen, setIsDeleteImageDialogOpen] = React.useState(false);
	const [selectedImage, setSelectedImage] = React.useState({});
	const [imageAnchorEl, setImageAnchorEl] = React.useState(null);
	const [anchorEl, setAnchorEl] = React.useState(null);


	let { facilityId } = useParams();
	let centreId = CENTRE._id;
	const handleClick = (event, selectedValue) => {
		event.preventDefault();
		setAnchorEl(event.currentTarget);
	};


	const triggerImagesMenu = (event, value) => {
		event.preventDefault();
		setImageAnchorEl(event.currentTarget);
		setSelectedImage(value);
	}

	const FACILITY_EDIT_FORM = useForm({
		resolver: yupResolver(createCentreFacilityFormSchema()),
		defaultValues: INITIAL_CENTRE_FACILITY_FORM
	});

	const triggerEditFacilityInfo = () => {
		setIsDialogOpen(true);
		FACILITY_EDIT_FORM.reset(FACILITY);
		setAnchorEl(null);
	};

	const triggerDeletePhoto = () => {
		setIsDeleteImageDialogOpen(true);
		setImageAnchorEl(null);
	}

	const triggerAddNewPhoto = () => {
		setIsUploadImageDialogOpen(true);
		setImageAnchorEl(null);
	}

	const deleteSelectedPhoto = () => {
		deleteFacilityPhoto({
			facilityId: facilityId,
			filename: selectedImage.filename
		});
	}

	React.useEffect(() => {

	}, []);


	React.useEffect(() => {

	}, [facilityId]);

	return (
		<React.Fragment>
			<Grid sx={{ marginBottom: "-2px" }} container>
				<Grid item xs={12} sx={{ maxHeight: { xs: "200px", sm: "300px" } }}>
					{FACILITY.photos ?
						(
							<Carousel maxHeight="300px" showThumbs={false} showStatus={false} infiniteLoop={true} showIndicators={false}>
								{FACILITY.photos.map((value) => (
									<CarouselImage centreId={centreId} key={value.filename + "_container"} value={value} triggerImagesMenu={triggerImagesMenu} />
								))}
							</Carousel>
						) :
						(
							<Carousel maxHeight="300px" showThumbs={false} showStatus={false} infiniteLoop={true} showIndicators={false}>
								<CarouselImage
									centreId={centreId}
									value={{
										src: FacilityDefaultImage,
										filename: "default.jpg"
									}} triggerImagesMenu={triggerImagesMenu} />
							</Carousel>
						)
					}
				</Grid>
			</Grid>

			<Paper sx={{ borderRadius: "0px 0px 10px 10px" }}>
				<Grid container>
					<SpaceHolder container item xs={0.5} />
					<Grid sx={{ paddingBottom: 1 }} container item xs={11}>
						<HeaderRow alignItems="center" justifyContent="space-between" container item xs={12}>
							<Typography sx={{ fontWeight: "bold" }} variant="h6" component="div">{t("general:section_title-about")}</Typography>
							<CanUpdateCentre centreId={centreId} >
								<IconButton onClick={(event) => {
									handleClick(event);
								}} aria-label="comment">
									<MoreHorizIcon />
								</IconButton>
							</CanUpdateCentre>
						</HeaderRow>
						<ContentRow content={FACILITY.description} />
						<ContentRow title={t("attribute:facility-function")} content={FACILITY.function} />
					</Grid>
					<SpaceHolder container item xs={0.5} />
				</Grid>
			</Paper>
			<ContextualMenu id="image-menu" anchorEl={imageAnchorEl} setAnchorEl={setImageAnchorEl}>
				{FACILITY.photos ? (<ContextualMenuItem title={t("general:button-delete")}
					onClick={triggerDeletePhoto}>
					<DeleteIcon sx={{ mr: 0 }} fontSize="small" />
				</ContextualMenuItem>) : null}
				<ContextualMenuItem title={t("general:button-add_entity", { entity: t("attribute:general-photos").toLowerCase() })} onClick={triggerAddNewPhoto}>
					<AddIcon sx={{ mr: 0 }} fontSize="small" />
				</ContextualMenuItem>
			</ContextualMenu>
			<ContextualMenu id="edit-menu" anchorEl={anchorEl} setAnchorEl={setAnchorEl} >
				<ContextualMenuItem title={t("general:button-edit")} onClick={triggerEditFacilityInfo}>
					<EditIcon sx={{ mr: 0 }} fontSize="small" />
				</ContextualMenuItem>
			</ContextualMenu>
			<CentreFacilityDialog title={t("general:dialog_title-edit_entity_info", { entity: t("attribute:facility") })} isDialogOpen={isDialogOpen} setIsDialogOpen={setIsDialogOpen} currentFacility={FACILITY} />
			<FacilityUploadImageDialog open={isUploadImageDialogOpen} setOpen={setIsUploadImageDialogOpen} />
			<ConfirmActionDialog
				title={t("general:dialog_title-delete_entity", { entity: t("attribute:general-photo") })}
				actionName={t("general:button-delete")}
				open={isDeleteImageDialogOpen}
				setOpen={setIsDeleteImageDialogOpen}
				confirmOnClick={deleteSelectedPhoto}
			/>
		</React.Fragment >
	);
}
